import { ModalBlockDeleteReason } from "components/molecules";
// import { RestoreUsersAction, UnblockUsersAction } from "store/middlewares/user";
import { Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
import { openAdminModal } from "store/slices/common/adminModal.slice";
import { Button } from "components/ui";
import {
  ArchiveRestore,
  EllipsisVertical,
  Info,
  // Info,
  RotateCw,
  ShieldBan,
  Trash,
} from "lucide-react";

import RestoreIconSVGModel from "assets/images/restoreIconSVGModel.svg";
import RestoreDeleteIconModel from "assets/images/restoreDeleteIconModel.svg";
import DeleteIconSVGModel from "assets/images/deleteIconSVGModel.svg";
import BlockIconModel from "assets/images/blockIconModel.svg";
import checkAccess from "utils/checkAccess";
import { StatusManageUserAction } from "store/middlewares/user";
import { useNavigate } from "react-router-dom";

const UserListActionBar = ({ row, filter }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //--------------------------------------------------- Action Menu Array --------------------------------------
  const ActionMenuArray = [
    {
      label: "Detail",
      icon: <Info size={16} color="#475569" />,
      onClick: () => {
        navigate(`/users/details/${row.id}`);
      },
    },
    row?.status === "active" &&
      checkAccess("update_users") && {
        label: "Block",
        icon: <ShieldBan size={16} color="#475569" />,
        onClick: () => {
          Swal.fire({
            title: "Are you sure you want to block this user?",
            imageUrl: BlockIconModel,
            imageWidth: 100,
            imageHeight: 100,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            customClass: {
              popup: "custom-swal-popup",
              title: "Swal-title-class",
              confirmButton: "custom-swal-confirm",
              cancelButton: "custom-swal-cancel",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(
                openAdminModal({
                  title: "Block Reason",
                  content: (
                    <ModalBlockDeleteReason
                      id={row.id}
                      type="blocked"
                      filter={filter}
                    />
                  ),
                })
              );
            }
          });
        },
      },
    checkAccess("delete_users") &&
      row?.status === "deleted" && {
        label: "Restore",
        icon: <ArchiveRestore size={16} color="#475569" />,
        onClick: () => {
          Swal.fire({
            title: `Are you sure you want to restore this user?`,
            imageUrl: RestoreDeleteIconModel,
            imageWidth: 100,
            imageHeight: 100,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            customClass: {
              popup: "custom-swal-popup",
              title: "Swal-title-class",
              confirmButton: "custom-swal-confirm",
              cancelButton: "custom-swal-cancel",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(
                StatusManageUserAction({
                  id: row.id,
                  status: "active",
                  filter,
                })
              );
            }
          });
        },
      },
    checkAccess("update_users") &&
      row?.status === "blocked" && {
        label: "Unblock",
        icon: <RotateCw size={16} color="#475569" />,
        onClick: () => {
          Swal.fire({
            title: `Are you sure you want to unblock this user?`,
            imageUrl: RestoreIconSVGModel,
            imageWidth: 100,
            imageHeight: 100,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            customClass: {
              popup: "custom-swal-popup",
              title: "Swal-title-class",
              confirmButton: "custom-swal-confirm",
              cancelButton: "custom-swal-cancel",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(
                StatusManageUserAction({
                  id: row.id,
                  status: "active",
                  filter,
                })
              );
            }
          });
        },
      },
    checkAccess("delete_users") &&
      row?.status === "active" && {
        label: "Delete",
        icon: <Trash size={16} color="#475569" />,
        onClick: () => {
          Swal.fire({
            title: "Are you sure you want to delete this user?",
            imageUrl: DeleteIconSVGModel,
            imageWidth: 100,
            imageHeight: 100,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            customClass: {
              popup: "custom-swal-popup",
              title: "Swal-title-class",
              confirmButton: "custom-swal-confirm",
              cancelButton: "custom-swal-cancel",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(
                openAdminModal({
                  title: "Delete Reason",
                  content: (
                    <ModalBlockDeleteReason
                      id={row.id}
                      type="deleted"
                      filter={filter}
                    />
                  ),
                })
              );
            }
          });
        },
      },
  ].filter(Boolean);

  // For action menu
  const [actionMenu, setActionMenu] = useState(null);
  const handleActionMenuOpen = (event) => {
    setActionMenu(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setActionMenu(null);
  };

  return (
    <MuiBox className="flex h-full items-center justify-center gap-3 ">
      <Button
        className="size-7"
        mode="icon"
        variant="ghost"
        onClick={handleActionMenuOpen}
      >
        <EllipsisVertical />
      </Button>

      <Menu
        anchorEl={actionMenu}
        open={Boolean(actionMenu)}
        onClose={() => handleActionMenuClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          " & .MuiMenu-paper": {
            mt: "10px",
            background: " size-4 z-0 #fff",
            boxShadow:
              " 0 4px 6px -1px #e2e8f0, 0 2px 4px -2px #e2e8f0 !important",
          },
        }}
      >
        {ActionMenuArray.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              handleActionMenuClose();
              option.onClick();
            }}
          >
            <MuiBox
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "9px",
              }}
            >
              <MuiBox sx={{ width: "fit-content" }}>{option.icon}</MuiBox>
              <MuiTypography
                sx={{ fontWeight: "500", fontSize: "13px", color: "#475569" }}
              >
                {option.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </MuiBox>
  );
};

export default UserListActionBar;
